module.exports = __webpack_public_path__ + "img/coin-5.00fbe15f.png";